import type { HubModelDependency } from '@robovision/hub'
import { JobBaseDependency } from './JobBaseDependency'


export class JobModelDependency extends JobBaseDependency {
  public static fromDefinition (
    modelDependency: HubModelDependency,
  ) {
    return new JobModelDependency({
      definitionId: modelDependency.modelDefinition,
      dependencyId: modelDependency.id,
      description: modelDependency.description,
      name: modelDependency.name,
    })
  }
}
